<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row>
        <el-row :gutter="24">
          <!-- 部门列表弹窗 -start  -->
          <el-col :span="5">
            <el-button class="iconfont icon-sync-alt" @click="handleClick" style="width: 100%" size="mini"> {{corpName}}</el-button>
            <depTree :visible="visible" :data="checked" @onClose="handleClose" @change="handleChange"></depTree>
          </el-col>


<!--          <el-col :span="3">-->
<!--            <el-select v-model="params.gender" placeholder="性别" size="mini">-->
<!--              <el-option label="全部" value=""></el-option>-->
<!--              <el-option label="男" value="1"></el-option>-->
<!--              <el-option label="女" value="2"></el-option>-->
<!--            </el-select>-->
<!--          </el-col>-->
<!--          <el-col :span="3">-->
<!--            <el-input placeholder="门店id" v-model="params.distributor_number" style="width: 100%" size="mini"></el-input>-->
<!--          </el-col>-->
<!--          <el-col :span="3">-->
<!--            <el-input placeholder="微信userid" v-model="params.wx_user_id" style="width: 100%" size="mini"></el-input>-->
<!--          </el-col>-->
<!--          <el-col :span="3">-->
<!--            <el-input placeholder="用户id" v-model="params.yaoking_user_id" style="width: 100%" size="mini"></el-input>-->
<!--          </el-col>-->

          <el-col :span="3">
            <el-select v-model="status" placeholder="状态" size="mini">
              <el-option
                v-for="item in options_status"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-input placeholder="姓名" v-model="name" style="width: 100%" size="mini"></el-input>
          </el-col>
          <el-col :span="3">
            <el-input placeholder="手机号" v-model="mobile" style="width: 100%" size="mini"></el-input>
          </el-col>
          <el-col :span="6">
            <el-date-picker
              v-model="created"
              type="month"
              @change="dateChange"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择月"  size="mini">
            </el-date-picker>
            <el-button type="primary" @click="searchData"  size="mini">搜索</el-button>
            <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
            <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
            <el-popover
              placement="top-start"
              width="200"
              trigger="hover"
              content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选分享签到’页面中查看及下载数据">
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </el-col>

        </el-row>
        </el-row>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>

      <div style="width: 110%;height: 250px;float: left;margin-top: 10px;white-space:normal;word-wrap:break-word;word-break:break-all;">
        <table class="gridtable" v-if="qiandaoData"  v-loading="loading">
          <thead>
          <tr>
            <th>姓名</th>
            <th>区域</th>
            <th>部门</th>
            <th>职位</th>
            <th>手机号</th>
            <th>状态</th>
            <th>签到天数</th>
            <th v-for="(vo,index) in days">{{vo}}</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(vo,index) in qiandaoData">
              <td v-text="vo.name"></td>
              <td v-text="vo.quyu"></td>
              <td v-text="vo.main_department"></td>
              <td v-text="vo.position"></td>
              <td v-text="vo.mobile"></td>
              <td v-text="vo.status_des"></td>
              <td v-text="vo.qiandao_days"></td>
              <template v-for="(vo2,index2) in days">
                <td  class="lanse" v-if="vo['days'][index2+1]=='1'">✔</td>
                <td class="hongse" v-else-if="vo['days'][index2+1]=='0'">✘</td>
                <td class="huise" v-else>-</td>
              </template>
            </tr>
          </tbody>
        </table>
        <div v-if="total_count > params.pageSize" class="content-padded tc">
          <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
          </el-pagination>
        </div>
      </div>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import depTree from '../../workwx/authorize/depTree'
import {getQianDao, qiandaoExport} from '../../../api/sharer'
import {mapGetters} from "vuex";
export default {
  components: {
    depTree,
  },
  data () {
    return {
      total_count: 0,
      loading: false,
      exportLoading: false,
      qiandaoData: [],
      days: 30,
      params: {
        page: 1,
        pageSize: 20
      },
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      created: '',
      visible: false,
      checked: {},
      corpName: "点击切换部门",
      corp_id: 8,
      status: '',
      name: '',
      mobile: '',
      options_status: [{
        value: '0',
        label: '全部'
      }, {
        value: '99',
        label: '在职'
      }, {
        value: '5',
        label: '已离职'
      }]
    }
  },
  computed: {
    // 默认时间
    timeDefault () {
      let date = new Date()
      // 通过时间戳计算
      let defalutTime = date.getTime()
      let DateNs = new Date(defalutTime)
      // 月，日 不够10补0
      defalutTime = DateNs.getFullYear() + '-' + ((DateNs.getMonth() + 1) >= 10 ? (DateNs.getMonth() + 1) : '0' + (DateNs.getMonth() + 1))
      this.params.time = defalutTime
      this.getItems()
      return defalutTime
    },
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getItems () {
      this.loading = true
      this.params.corp_id = this.params.corp_id ? this.params.corp_id : this.corp_id
      getQianDao(this.params).then(response => {
        this.qiandaoData = response.data.data.list
        this.days = response.data.data.days
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
        this.exportLoading = false
      })
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getItems()
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    dateChange (val) {
      if (val && val.length > 0) {
        this.params.time = val
      } else {
        this.params.time = ''
      }
      this.params.page = 1
      // this.getItems()
    },
    handleClick () {
      this.visible = true
    },
    handleClose () {
      this.visible = false
    },
    handleChange (arr) {
      this.params.department_id = arr.wx_department_id
      this.params.corp_id = arr.corp_id
      this.corpName = arr.name?arr.name:arr.cropname
      this.visible = false
    },
    searchData () {
      this.params.status = this.status
      this.params.name = this.name
      this.params.mobile = this.mobile
      this.params.page = 1
      this.getItems()
    },
    exportData () {
      this.exportLoading = true
      qiandaoExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-优选分享签到中下载'
          })
          return
        } else if (response.data.url) {
          this.downloadUrl = response.data.url
          this.downloadName = response.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    }
  },
  created () {
    this.created = this.timeDefault
  },
  mounted () {
    // this.getItems()
  },
  watch: {
    // 分页全选-监听数据变化
  }
}
</script>
<style  scoped lang="scss">
table.gridtable th {
  border-color: #1480e3;
  background-color: #1480e3;
  color: #fff6f7;
  font-weight: bold;
}
table.gridtable td {
  font-weight: bold;
}
.hongse{
  color: #d44d44;
  font-weight: bold;
}
.lanse{
  color: #409eff;
  font-weight: bold;
}
.huise{
  color: #abb6c7;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// qiandao.vue?55addfab